export const TRIP_TYPE_EMOJI = { vuelo: "✈️", paquete: "🌴", circuito: "🗺️", crucero: "🚢", otros: "🧳" };

// Dates are stored as UTC midnight: format in UTC so the day never shifts.
export const fmtDate = (d) =>
  d ? new Date(d).toLocaleDateString("es-AR", { timeZone: "UTC", day: "2-digit", month: "2-digit", year: "numeric" }) : null;

export const toInputDate = (d) => (d ? new Date(d).toISOString().slice(0, 10) : "");

export const fromInputDate = (s) => (s ? new Date(s).toISOString() : null);

export const tripTitle = (t) => t?.trip_destination || "Viaje sin destino";

export const tripDatesLabel = (t) => {
  const dep = fmtDate(t?.trip_date);
  const ret = fmtDate(t?.return_date);
  if (!dep) return "Sin fecha";
  return ret ? `${dep} → ${ret}` : `Sale ${dep}`;
};

export const daysUntil = (d) => {
  const today = new Date();
  const utcToday = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
  return Math.round((new Date(d).getTime() - utcToday) / 86400000);
};
